import React from 'react';
import { Button } from 'react-bootstrap';
import { stringify } from 'query-string';
import { OneloginContext } from '../../../utils/OneLogin/context';

export const OneloginButton = (props) => {
  const { oneloginSec } = React.useContext(OneloginContext);
  const authority = 'https://aacounty.onelogin.com/oidc/2';
  const client_id = '54c34850-1aee-013a-790b-06bcd9da5417192439';
  const redirect_uri = `${(window as any)._env_.REACT_APP_FRONTEND}/auth`;
// const redirect_uri = 'http://localhost:3000/auth'
  const response_type = 'id_token token';
  const scope = 'openid profile';
  const state = oneloginSec.state;
  const nonce = oneloginSec.nonce;

  const params = stringify({
    client_id,
    redirect_uri,
    response_type,
    scope,
    state,
    nonce,
  });

  const authUrl = `${authority}/auth?${params}`;

  const oneloginRedirect = () => {
    window.location.assign(authUrl);
  };

  return (
    <Button variant={props.variant ? props.variant : 'info'} className='text-white mt-2' style={{ borderRadius: 12 }} onClick={oneloginRedirect}>
      {/* <i className='fa fa-circle-1' style={{paddingRight: '0.5em'}}/> */}
      <b>{props.title ? props.title : 'Sign In'}</b>
    </Button>
  );
};
